// import React ,{useEffect}from 'react'
// import styles from './StateHeader.module.scss'
// import Content from '../../../components/Content'
// import Layout from '../../../components/Layout'
// import GeoProvider from '../../../components/GeoProvider'
// import DashboardMap from './DashboardMap'
// import dataDisplayOptions from './../dataDisplayOptions'
// import { startDate, endDate, displayDate } from './../dates'
// import Header from './Header'
// import Gender from '../../GenderAge'
// import SeasonalPattern from '../../SeasonalPattern'
// import SystemNotification from './../../Dashboard/SystemNotification'
// import { useLocation } from 'react-router-dom'
// import { useGeoState, useGeoFetch } from '../../../components/GeoProvider'
// import DisplayDateFluNew from '../../../../components/DisplayDateFlu/DisplayDateFluNew'
// import Spinner from '../../../../components/Loader/Spinner'
// import MapOptions from '../../../../components/MapOptions'
// import EmptyMap from '../../../../components/Map/emptyMap'
// import Timeline from '../../../../components/Timeline'
// import Map from '../../../../components/Map'
// import regionDisplayOptions from './regionDisplayOptions'
// import dataDisplayOptions from './dataDisplayOptions'
// import toolTipFormatter from './toolTipFormatter'
// import MapLegend from './cdcMapLegendHorizontal'
// import StateStats from './StateStats'
// import CbsaStats from './CbsaStats'
// import Zip3Stats from './Zip3Stats'
// import { lastDisplayDate } from '../../dates'
// import { lastDisplayDateNew } from '../../dates'
// import FluDetailedViewComponent from './FluDetailedViewComponent'
// import FluMsaApi from './FluMsaApi'
import { useParams } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import GeoProvider from '../../../components/GeoProvider'
import Gender from '../../GenderAge'
import SeasonalPattern from '../../SeasonalPattern'
import styles from './StateHeader.module.scss'
import Content from '../../../components/ContentPharma'
import Layout from '../../../components/Layout'
import DashboardMap from './DashboardMap'
import { startDate, endDate, displayDate,actualsStartDate,forecastsStartDate } from '../dates'
import Header from './Header'
import dataDisplayOptions from '../FluTabs/FluMap/dataDisplayOptions'

const FluStateDashboard = () => {
  const { area, loc } = useParams()
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'state'}
            >
              {/* <SystemNotification/> */}
              <Header headerType={area} headerNumber={2} geo_id={loc} />
              <DashboardMap
                geo_type={area}
                geo_parent={loc}
                zoomLocation={loc}
              />
              <Gender geo_type={area} geo_id={loc} data_type="FLU"/>
              <SeasonalPattern geo_type={area} geo_id={loc} data_type="FLU"/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default FluStateDashboard
